import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./TabbedFormLayout.module.scss";

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabbedFormLayoutProps {
  tabs: Tab[];
  onSave?: () => void;
  onCancel?: () => void;
  showActions?: boolean; // Show Save/Cancel if true, Back button if false
  backType?: string; // Navigation type: "-1" for history back, or a route like "/dashboard"
}

const TabbedFormLayout: React.FC<TabbedFormLayoutProps> = ({
  tabs,
  onSave,
  onCancel,
  showActions = true,
  backType = "/dashboard", // Default to /dashboard
}) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0]?.label || "");
  const navigate = useNavigate();
  const activeTab = tabs.find((tab) => tab.label === selectedTab);

  const handleBack = () => {
    console.log("[TabbedFormLayout] Back button clicked, navigating to:", backType);
    if (backType === "-1") {
      navigate(-1);
    } else {
      navigate(backType);
    }
  };

  if (!tabs.length) {
    console.error("[TabbedFormLayout] No tabs provided");
    return <div>No tabs available</div>;
  }

  return (
    <div className={styles.editorPage}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={selectedTab === tab.label ? styles.activeTab : ""}
            onClick={() => {
              console.log("[TabbedFormLayout] Switching to tab:", tab.label);
              setSelectedTab(tab.label);
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.editorContent}>{activeTab?.content || <div>No content available</div>}</div>

      <div className={styles.actions}>
        {showActions ? (
          <>
            <button onClick={onSave} className={styles.saveBtn} disabled={!onSave}>
              Save
            </button>
            <button onClick={onCancel} className={styles.cancelBtn} disabled={!onCancel}>
              Cancel
            </button>
          </>
        ) : (
          <button onClick={handleBack} className={styles.backBtn}>
            ← Back
          </button>
        )}
      </div>
    </div>
  );
};

export default TabbedFormLayout;
